import React from 'react';
import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Success = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Success} />;

export default Success;
